

















































































































































































































import { Component, Vue, Provide, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { LowElement } from '@/types/Element';
import { ModelType } from '@/store/entities/Page';
import { TypeType } from '@/store/index';

import { modelConfig } from '@/components/common/index';
import { cloneDeep } from 'lodash'
import { generateUUID } from '@/utils';
@Component({
  name: 'low-model',
})
export default class LowModel extends Vue {

  createAndEditModelDialog = false;

  modelForm = {
    name: '',
    key: '',
    entities: [{
      name: '',
      value: '',
      type: 'string',
      key: ''
    }],
  };

  @State('globalModels')
  models?: ModelType[];

  @State('types')
  modelTypes?: TypeType[];

  @State('currentId', { namespace: 'page' })
  currentId?: string;

  @Getter('current', { namespace: 'page' })
  current?: LowElement;

  @Watch('currentId')
  currentWatch () {

    if (!this.current) return;
    const models = this.current.models;
    if (!models) {
      this.form.models = {};
      return;
    }

    this.form.models = Object.keys(models).reduce((pv: any, key: string) => {
      pv[key] = models[key].split('.');
      return pv;
    }, {});
    console.log('this.form.models ', this.form.models);

  }

  get cascaderOptions () {
    return this.models;
  }

  get modelConfigFormItems () {
    if (!this.current) return [];
    return modelConfig[this.current.element];
  }

  get rules () {
    return {
      model: [
        { required: true, message: '请选择', trigger: 'change' },
      ],
    }
  }

  form = {
    models: {}
  }


  created () {
    this.currentWatch();
  }

  onSubmit () {
    const formModels: any = this.form.models;

    const models = Object.keys(formModels).reduce((pv: any, key: string) => {
      pv[key] = (formModels[key] || []).join('.');
      return pv;
    }, {});
    this.$store.commit("page/BIND_MODELS", models);
    this.onClose();
  }
  onClose () {
    this.$store.commit("page/SET_CURRENT", undefined);
  }

  handleDeleteItemModel (data: ModelType) {
    this.$store.commit('REMOVE_MODEL', data.key);
    this.$message.success("成功");
  }

  handleShowModelEditAndAddDialog (data?: ModelType) {
    this.createAndEditModelDialog = true;
    if (!data) return; // 表示直接打开

    data = cloneDeep(data);
    const entities = data.entities;

    data.entities = entities.map(item => {
      // item.value = JSON.parse(item.value);
      // item.value = item.value;
      return item;
    });

    this.modelForm = data;
  }

  handleAddFormEntity () {
    this.modelForm.entities.push({
      key: '',
      name: '',
      value: '',
      type: 'string'
    });
  }
  handleRemoveEntityItem (index: number) {
    this.modelForm.entities.splice(index, 1);
  }

  handleCreateAndEditModelDialogClose () {
    // TODO: 目前只要是关闭就直接清空
    this.modelForm = {
      name: '',
      key: '',
      entities: [{
        name: '',
        value: '',
        type: 'string',
        key: ''
      }]
    };
  }

  handleCreateAndEditModelDialogSubmit () {
    (this.$refs['modelForm'] as any).validate(async (valid: boolean) => {
      if (!valid) return;
      // TODO: 保存
      // 转换数据
      const modelTypes = this.modelTypes || [];
      const modelForm = cloneDeep(this.modelForm);
      const entities = modelForm.entities;

      if (!modelForm.key) {
        modelForm.key = generateUUID(true);
      }

      try {
        // 得到keys,判断entitykey是否唯一
        const keys = modelForm.entities.map(item => item.key);
        const size = new Set(keys).size;
        if (size !== modelForm.entities.length) {
          throw new Error("实体中存在重复的实体字段，请确保字段唯一");
        }
        modelForm.entities = entities.map(entity => {
          // 处理value 
          // TODO: 校验数据 还需要复杂一点
          if (!entity.value) {
            const type = modelTypes.find(type => type.type === entity.type);
            entity.value = type?.value || '';
          } else {
            if (entity.type === 'string') {
              entity.value = JSON.stringify(entity.value);
            } else {
              try {
                // 校验
                entity.value = JSON.stringify(JSON.parse(entity.value));
              } catch (error) {
                throw new Error(entity.name + "的数据错误，请检查");
              }
            }
          }
          return entity;
        });
      } catch (error) {
        this.$message.warning(error.message);
        throw error;
      }
      try {
        // 执行添加模型
        await this.$store.dispatch('handleEditOrAddModel', modelForm);
        this.$message.success("操作成功");
        this.$nextTick(() => {
          this.createAndEditModelDialog = false;
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    });
  }

}
